module.exports = __webpack_public_path__ + "img/25-mustang.f150b473.png";